import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { MinuteService } from '../../../service/minute/minute.service';
import { Minute } from '../../../class/minute';

@Component({
  selector: 'app-minute',
  templateUrl: './minute.component.html',
  styleUrls: ['./minute.component.scss']
})
export class MinuteComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoMinute: Minute;
    public minute: Minute;
    public msgs: Message[] = [];
    public options: any;

    constructor(
        public minuteService: MinuteService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    public cancelMinute () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/minutes/minute/minute.component.ts